import React, { useEffect, useState } from "react";
import "./Orders.css";
import { Container, Row, Card, Col, Form } from "react-bootstrap";
import Sidebar from "../../components/SidebarInvestigator/Sidebar";
import {
  DeleteOrderDoc,
  OrderDetailsByID,
  UpdateOrder,
  UpdateOrderStatus,
} from "../../apis/OrderAPI";
import { Link, useSearchParams } from "react-router-dom";
import dateFormat from "dateformat";
import * as BsIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import {
  GetBase64,
  ShowDocument,
  ShowOrderDocument,
} from "../../utils/Utility";
import { confirmAlert } from "react-confirm-alert";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";

export default function OrderDetail() {
  const { user } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const orderid = searchParams.get("id");
  const [orderdata, setOrderData] = useState([]);
  const [reportdata, setReportData] = useState([]);
  const [attachements, setAttachments] = useState([]);
  const [reportAttachments, setReportAttachments] = useState([]);
  const [formDetail, setFormDetail] = useState([]);
  const [primaryReportId, setPrimaryReportId] = useState(0);
  const alert = useAlert();
  const [pdfReport, setPdfReport] = useState(false);
  const [orderStatus, setOrderStatus] = useState(0);

  const [showStrtLoader, setShowStrtLoader] = useState(false);
  const [showPrlmLoader, setShowPrlmLoader] = useState(false);
  const [showCmpltLoader, setShowCmpltLoader] = useState(false);
  const [showQALoader, setShowQALoader] = useState(false);

  useEffect(() => {
    async function GetOrderData() {
      var result = await OrderDetailsByID(orderid, "view");
      var data = result.data;
      setOrderStatus(data.item1.order_status_id);
      setOrderData(data.item1);
      setReportData(data.item3);
      const rpt = data.item3.filter((rpt) => rpt.is_primary);
      if (rpt.length > 0) {
        if (rpt[0].template_name.includes("Pdf Reports")) setPdfReport(true);
        setPrimaryReportId(rpt[0].order_report_mapping_id);
      }
      var attachs = data.item4;
      setAttachments(attachs.filter((a) => a.attachment_type === "order"));
      let rattachs = attachs.filter((a) => a.attachment_type === "report");
      let attList = [];
      rattachs.map((item) => {
        attList.push({
          id: item.order_attachment_id,
          documentName: item.attachment_name,
          documentPath: null,
          attachmentType: "report",
        });
      });
      setReportAttachments(attList);
      setFormDetail(data.item5);
    }
    GetOrderData();
  }, [orderid]);

  function handleFileChange(event) {
    const files = Array.prototype.slice.call(event.target.files);
    let uploadFiles = [];
    let msg = "";
    files.some((file) => {
      if (
        file.size <= 25000000 &&
        !file.type.includes("application/x-msdownload")
      ) {
        GetBase64(file, (result) => {
          uploadFiles.push({
            id: 0,
            documentName: file.name.split(".").slice(0, -1).join("."),
            documentPath: result,
            attachmentType: "report",
          });
          setReportAttachments([...reportAttachments, ...uploadFiles]);
        });
      } else msg += `${file.name} exceeds the limit of 25mb.`;
      document.getElementById("attach_upload").value = "";
    });
    if (msg !== "") alert.error(msg);
    //console.log(uploadFiles);
  }

  const viewDocument = (item) => {
    let id = item.id;
    if (id === 0) ShowDocument(item.documentPath);
    else ShowOrderDocument(id);
  };

  const deleteDoc = async (item) => {
    let id = item.id;
    if (id !== 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you sure want to delete this report attachment?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              var result = await DeleteOrderDoc(id);
              if (result.status === 200) {
                alert.success("Report attachment deleted", {
                  onOpen: () => {
                    let docs = reportAttachments.filter(
                      (x) => x.documentName !== item.documentName
                    );
                    setReportAttachments(docs);
                  },
                });
              } else alert.error("Unable to remove report attachment");
            },
          },
          { label: "No" },
        ],
      });
    } else {
      let docs = reportAttachments.filter(
        (x) => x.documentName !== item.documentName
      );
      setReportAttachments(docs);
    }
  };

  async function UpdateStatus(msg, statusid) {
    var result = await UpdateOrderStatus(orderid, statusid + "", user.userid);
    if (result.status === 200) {
      alert.success(msg, {
        onOpen: () => {
          setOrderStatus(statusid);
          if (reportAttachments.length > 0) handleUpdateOrder();
        },
        onClose: () => {
          window.location.reload();
        }
      });
    } else alert.error("Unable to update order");
  }

  const handleReport = async (type, statusid) => {
    if (!pdfReport) {
      if (reportAttachments.length > 0) handleUpdateOrder();
      window.open(`/Report?type=${type}&id=${primaryReportId}`, "_blank");
    } else {
      let msg = "Order reporting marked as in progress.";
      if (type === "prelim") msg = "Prelim report submitted successfully";
      if (type === "complete") {
        msg = "Order completed successfully.";
        confirmAlert({
          title: "Update Order",
          message:
            "Are you sure want to mark this order complete? You will not be able to make any further changes.",
          buttons: [
            {
              label: "Yes",
              className: "yesbtn",
              onClick: () => UpdateStatus(msg, statusid),
            },
            {
              label: "No",
              className: "nobtn",
            },
          ],
        });
      } else {
        if (reportAttachments.length == 0) {
          confirmAlert({
            title: "Update Order",
            message: "Do you want to continue without report attachment?",
            buttons: [
              {
                label: "Yes",
                className: "yesbtn",
                onClick: () => UpdateStatus(msg, statusid),
              },
              {
                label: "No",
                className: "nobtn",
              },
            ],
          });
        } else UpdateStatus(msg, statusid);
      }
    }
  };

  async function handleUpdateOrder() {
    var order = {
      id: orderid,
      totalRows: 0,
      orderApplicantName: orderdata.order_applicant_name,
      orderCoApplicant: orderdata.order_co_applicant,
      orderCustomerName: "",
      orderCustomerIdRef: orderdata.customer_id,
      orderUserIdRef: user.userid,
      orderRequestorIdRef: "0",
      orderAddress: orderdata.order_address,
      orderNotes: "",
      orderStartDate: "",
      orderEndDate: orderdata.order_end_date,
      orderPo: orderdata.order_po,
      orderTaxes: orderdata.tax_id + "",
      orderInvestigatorId: orderdata.order_investigator_id,
      orderRestriction: orderdata.customer_restrictions,
      investigatorName: "",
      orderAmount: orderdata.order_amount + "",
      orderStatusId: orderStatus,
      orderStatusName: "",
      orderPrelimReportDate: "",
      orderTimestamp: "",
      miscPrice: JSON.stringify([]),
      userName: "",
      requestorName: "",
      reportId: "0",
      reportsName: "",
      reports: JSON.stringify([]),
      adminInstruction: orderdata.order_admin_instruction,
      customerInstruction: orderdata.order_customer_instruction,
      billingInformation: orderdata.order_billing_information,
      applicantFormId: 0,
      attachments: reportAttachments,
      orderBillingEntity: JSON.stringify({
        billing_entity_id: orderdata.billing_entity_id ?? 0,
        billing_entity_name: "",
      }),
      orderRef: orderdata.order_ref,
    };
    orderStatus == 6
      ? setShowStrtLoader(true)
      : orderStatus == 7
      ? setShowPrlmLoader(true)
      : orderStatus == 9 || orderStatus == 11
      ? setShowQALoader(true)
      : setShowCmpltLoader(true);
    var result = await UpdateOrder(order);
    if (result.status === 200) {
      alert.success("Order updated successfully", {
        onClose: () =>
          orderStatus == 6
            ? setShowStrtLoader(false)
            : orderStatus == 7
            ? setShowPrlmLoader(false)
            : orderStatus == 9 || orderStatus == 11
            ? setShowQALoader(false)
            : setShowCmpltLoader(false),
      });
    } else
      alert.error("Unable to update order", {
        onClose: () =>
          orderStatus == 6
            ? setShowStrtLoader(false)
            : orderStatus == 7
            ? setShowPrlmLoader(false)
            : orderStatus == 9 || orderStatus == 11
            ? setShowQALoader(false)
            : setShowCmpltLoader(false),
      });
  }

  const handleQA = () => {
    let msg =
      "Order report sent for review. You will get notification once reviewed.";
    if (pdfReport && reportAttachments.length == 0) {
      confirmAlert({
        title: "Send order to QA",
        message: "Do you want to continue without report attachment?",
        buttons: [
          {
            label: "Yes",
            className: "yesbtn",
            onClick: () => {
              if (orderStatus === 6) UpdateStatus(msg, 9);
              if (orderStatus === 7) UpdateStatus(msg, 11);
            },
          },
          {
            label: "No",
            className: "nobtn",
          },
        ],
      });
    } else {
      if (orderStatus === 6) UpdateStatus(msg, 9);
      if (orderStatus === 7) UpdateStatus(msg, 11);
    }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="mt-5">
                  <Col lg={12} xs={12}>
                    {orderdata.do_qa && (
                      <div style={{ textAlign: "right", paddingBottom: "5px" }}>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleQA}
                          disabled={
                            orderStatus == 6 || orderStatus == 7 ? false : true
                          }
                        >
                          Send to QA
                          <Loader visible={showQALoader} ibutton={true} />
                        </button>
                      </div>
                    )}

                    <Card className="notifications-card investigator-oderdetails-card">
                      <div className="card-head">
                        <div className="card-title h5">Orders Details</div>
                        <Link to="/Investigator/Orders" className="back-btn">
                          <BsIcons.BsArrowLeft />
                        </Link>
                      </div>
                      <Row className="detail-box">
                        <Col xl={6} lg={12} md={12} className="mb-5">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item">
                                <span>Order No:</span> {orderdata.order_id}
                              </div>
                              <div className="cards-list-item">
                                <span>Order Date:</span>{" "}
                                {dateFormat(
                                  orderdata.order_start_date,
                                  "mm/dd/yyyy"
                                )}
                              </div>
                              <div className="cards-list-item">
                                <span>Customer Name:</span>{" "}
                                {orderdata.customer_first_name}{" "}
                                {orderdata.customer_last_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Customer No:</span>{" "}
                                {orderdata.customer_id}
                              </div>
                              <div className="cards-list-item">
                                <span>Requestor:</span>{" "}
                                {orderdata.requestor_first_name}{" "}
                                {orderdata.requestor_last_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Applicant:</span>{" "}
                                {orderdata.order_applicant_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Address:</span> {orderdata.order_address}
                              </div>
                              <div className="cards-list-item">
                                <span>Due Date:</span>{" "}
                                {orderdata.order_end_date &&
                                  dateFormat(
                                    orderdata.order_end_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item">
                                <span>Applicant Form:</span>{" "}
                                {formDetail.map((item) => (
                                  <p key={item.application_id}>
                                    <span>
                                      <Link
                                        to={`/Form?token=view&id=${item.form_id}&applicationid=${item.application_id}&custId=${orderdata.customer_id}`}
                                        target="_blank"
                                      >
                                        {item.form_name}
                                      </Link>
                                    </span>
                                  </p>
                                ))}
                              </div>
                              <div className="cards-list-item">
                                <span>Attachment(s):</span>{" "}
                                {attachements.map((item) => (
                                  <p key={item.order_attachment_id}>
                                    <span>
                                      <Link
                                        to={`?id=${orderid}`}
                                        onClick={() =>
                                          ShowOrderDocument(
                                            item.order_attachment_id
                                          )
                                        }
                                      >
                                        {item.attachment_name}
                                      </Link>
                                    </span>
                                  </p>
                                ))}
                              </div>
                              <div className="cards-list-item">
                                <span>Report Attachment(s):</span>{" "}
                                {reportAttachments.map((item) => (
                                  <p key={item.id}>
                                    <span>
                                      <Link
                                        to={`?id=${orderid}`}
                                        onClick={() => viewDocument(item)}
                                      >
                                        {item.documentName}
                                      </Link>{" "}
                                      <button
                                        type="button"
                                        className="deltbtnbox"
                                        onClick={() => deleteDoc(item)}
                                      >
                                        <MdIcons.MdDeleteForever />
                                      </button>
                                    </span>
                                  </p>
                                ))}
                                <input
                                  id="attach_upload"
                                  type="file"
                                  multiple
                                  onChange={handleFileChange}
                                  className={
                                    orderStatus === 6 ||
                                    orderStatus === 7 ||
                                    orderStatus === 8
                                      ? ""
                                      : "no-display"
                                  }
                                />
                              </div>
                              <div className="cards-list-item">
                                <span>Report Type:</span>{" "}
                                {reportdata.map((item) => (
                                  <p key={item.order_report_mapping_id}>
                                    <span>
                                      {!item.is_primary || pdfReport ? (
                                        item.report_name
                                      ) : (
                                        <Link
                                          to={`/Report?type=view&id=${item.order_report_mapping_id}`}
                                          target="_blank"
                                        >
                                          {item.report_name}
                                        </Link>
                                      )}
                                    </span>
                                  </p>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xl={6} lg={12} md={12} className="mb-5">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item">
                                <span>Status:</span>{" "}
                                {orderdata.order_status_name}
                              </div>

                              <div className="cards-list-item">
                                <span>Completion Date:</span>{" "}
                                {orderdata.order_completion_date &&
                                  dateFormat(
                                    orderdata.order_completion_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item">
                                <span>Co-Applicant:</span>{" "}
                                {orderdata.order_co_applicant}
                              </div>
                              <div className="cards-list-item">
                                <span>Billing Entity:</span>{" "}
                                {orderdata.billing_entity_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Re/PO#:</span> {orderdata.order_po}
                              </div>
                              <div className="cards-list-item">
                                <span>References:</span> {orderdata.order_ref}
                              </div>
                              <div className="cards-list-item">
                                <span>Investigator:</span>{" "}
                                {orderdata.investigator_first_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Restriction:</span>{" "}
                                {orderdata.customer_restrictions}
                              </div>
                              <div className="cards-list-item">
                                <span>Prelim Report Date:</span>{" "}
                                {orderdata.order_prelim_report_date &&
                                  dateFormat(
                                    orderdata.order_prelim_report_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item">
                                <span>Other Instructions (from Customer):</span>{" "}
                                <p>{orderdata.order_customer_instruction}</p>
                              </div>
                              <div className="cards-list-item">
                                <span>Other Instructions (from Admin):</span>{" "}
                                <p>{orderdata.order_admin_instruction}</p>
                              </div>
                              <div className="cards-list-item">
                                <span>Need QA:</span>{" "}
                                <Form.Check
                                  type="checkbox"
                                  inline
                                  checked={orderdata.do_qa}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="order-buttons">
                        <Col
                          lg={4}
                          md={12}
                          className="mb-5 ordbtn disabled-btnnew"
                        >
                          <Link to={`/investigator/orderdetails?id=${orderid}`}>
                            <button
                              type="button"
                              className="orange-btn"
                              onClick={() => handleReport("start", 6)}
                              disabled={
                                (orderStatus === 8 || orderStatus === 6) &&
                                setPrimaryReportId !== "0"
                                  ? false
                                  : true
                              }
                            >
                              {orderStatus === 8
                                ? "Start Report"
                                : "Edit Report"}
                              <Loader visible={showStrtLoader} ibutton={true} />
                            </button>
                          </Link>
                        </Col>
                        <Col
                          lg={4}
                          md={12}
                          className="mb-5 ordbtn disabled-btnnew"
                        >
                          <Link to={`/investigator/orderdetails?id=${orderid}`}>
                            <button
                              type="button"
                              className="gray-btn"
                              onClick={() => handleReport("prelim", 7)}
                              disabled={orderStatus === 10 || (orderStatus === 6 && !orderdata.do_qa) ? false : true}
                            >
                              Mark Preliminary
                              <Loader visible={showPrlmLoader} ibutton={true} />
                            </button>
                          </Link>
                        </Col>
                        <Col
                          lg={4}
                          md={12}
                          className="mb-5 ordbtn disabled-btnnew"
                        >
                          <Link to={`/investigator/orderdetails?id=${orderid}`}>
                            <button
                              type="button"
                              className="blue-btn"
                              onClick={() => handleReport("complete", 3)}
                              disabled={orderStatus === 12 || (orderStatus === 7 && !orderdata.do_qa) ? false : true}
                            >
                              Mark Complete
                              <Loader
                                visible={showCmpltLoader}
                                ibutton={true}
                              />
                            </button>
                          </Link>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
